import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";
import { applyColorScheme, getStoredColorScheme } from "@/lib/preferences";
import { recordBrowserFirstTouchOnce } from "@/lib/acquisition";
import { startLocaleSync } from "@/lib/i18n";

// Apply dark mode from system preference or stored preference
function initTheme() {
  applyColorScheme(getStoredColorScheme());
}
initTheme();
recordBrowserFirstTouchOnce();
const stopLocaleSync = startLocaleSync();
if (import.meta.hot) import.meta.hot.dispose(stopLocaleSync);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
